import React from 'react';
import clsx from 'clsx';
// import CircularProgress from '@mui/material/CircularProgress';

const Button = ({
  children,
  loading,
  disabled,
  onClick,
  className,
  ...props
}: any) => {
  return (
    <button
      {...props}
      className={clsx(
        'px-3 py-1 hover:brightness-110',
        className,
        disabled && 'opacity-50'
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {loading ? (
        <div className="flex items-center gap-x-3">
          {/* <CircularProgress className="!h-5 !w-5" /> */}
          {children}
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
